<template>
  <div class="cpn-mask">
    <div class="box">
      <img src="../assets/img/arrow.png" alt="" class="arrow">
      <div class="text">
        <p>{{ $t('download_tip.text1') }}</p>
        <p>{{ $t('download_tip.text2') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="less" scoped>
.cpn-mask {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,.8);
  z-index: 1200;
  text-align: center;
  vertical-align: middle;
  text-align: right;
  .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-top: 15px;
    padding-right: 15px;
    .arrow {
      width: 123px;
      height: auto;
      margin-bottom: 10px;
    }
    .text {
      p {
        width: 250px;
        margin-bottom: 5px;
        font-size: 18px;
        color: #fff;
        text-align: center;
      }
    }
  }
}
</style>
